
export const setEmailBodyEduconConfirma = (props) => {
    const styles = {
        p: { border: "1px solid gray", width: "380px", backgroundColor: "#ddd" },
        div: {
            border: "1px solid gray",
            width: "380px",
            padding: "0 20px",
            margin: "10px 0",
            backgroundColor: "#ddd",
        },
        divWhite: {
            textAlign: "center",
            width: "380px",
            padding: "0 20px",
            margin: "10px 0",
            backgroundColor: "#fff",
        },
        divWhiteLeft: {
            border: "1px solid gray",
            width: "380px",
            padding: "10px 20px",
            margin: "10px 0",
            backgroundColor: "#fff",
        },
        divWhiteLeftNoBorder: {
            width: "380px",
            padding: "10px 20px",
            margin: "10px 0",
            backgroundColor: "#fff",
        },
        li: { padding: "6px 0" },
    };

    const { formValues: data, urlArchivo } = props;

    let docAnexo = '';
    if (urlArchivo !== '') {
        docAnexo =
        <p>
            <a href={urlArchivo}>
                <strong>Enlace para consultar el documento probatorio</strong>
            </a>
        </p>;
    }

    let facturaValue = '';
    const solicitaFactura = data.requiereFactura;

    switch (solicitaFactura) {
        case 'No':
            facturaValue = <p>Facturación: <strong>NO requiere factura</strong></p>;
            break;
        case 'Si':
            facturaValue = 
                <p>Facturación: <strong>SI requiere factura</strong><br /><br />
                    Nombre a facturar: {data.factNombre}<br />
                    RFC: {data.factRFC}<br />
                    C.P.: {data.factCP}<br />
                    Uso CFDI (clave): {data.factUsoCFDI}<br />
                    Regimen fiscal (clave): {data.factRegimenFiscal}<br />
                </p>;
            break;
        case 'SiExt':
            facturaValue = 
                <p>Facturación: <strong>SI requiere factura para el extranjero</strong><br /><br />
                    País: {data.factExtPais}<br />
                    Nombre a facturar: {data.factExtNombre}<br />
                    Concepto: {data.factExtConcepto}<br />
                </p>;
            break;
    
        default:
            break;
    }


    return (
        <>
            <div style={styles.divWhite}>
                <img src="https://eventos.cibnor.mx/registro/educon/images/logo_posgradoCib.png" alt="logo" width={300} ></img>
            </div>
            <div style={styles.divWhite}>
                <p>¡Su comprobante ha sido recibido con éxito!</p>
                <h2>Numero de referencia: <br />{data.registroReferencia}</h2>
            </div>
            <div style={styles.div}>
                <h4>Datos generales</h4>
                <p>
                    Nombre completo: {data.partNombres} {data.partApellidoPaterno} {data.partApellidoMaterno}<br />
                    Correo: {data.partCorreo}<br />
                    Procedencia: {data.partEstado}, {data.partPais}<br />
                </p>
            </div>
            <div style={styles.div}>
                <h4><i>{data.educonTitulo}</i></h4>
                <p>
                    Tipo de inscripción: {data.tipoRegistro}<br />
                    { (urlArchivo !== '') ? docAnexo : '' }
                </p>
            </div>

            <div style={styles.div}>
                {facturaValue}
            </div>

            <div style={styles.divWhiteLeft}>
                {/* <ul>
                    <p> */}
                        En breve el organizador titular se pondrá en contacto al correo electrónico registrado. Favor de revisar la bandeja de correos recibidos y no deseados.
                    {/* </p>
                </ul> */}
            </div>
            <div style={styles.divWhiteLeftNoBorder}>
                <strong><i>Atentamente,<br/>Comité organizador</i></strong>
            </div>
        </>
    );
};
